import React from 'react';
import { FileText } from 'lucide-react';
import Header from './components/Header22';
import Footer from './components/Footer22';

const TermsAndConditions22 = () => {
    const sections = [
        {
            id: 'general-terms',
            title: '1. General Terms',
            paragraphs: [
                'Welcome to our online handloom and artisan fashion store. By accessing, browsing, or placing an order on this website, you acknowledge that you have read, understood, and agree to be bound by these Terms and Conditions. These terms apply to all visitors, users, and customers of the website.',
                'We reserve the right to update, modify, or replace any part of these Terms and Conditions at our sole discretion. It is your responsibility to check this page periodically for changes. Your continued use of the website following the posting of any changes constitutes acceptance of those changes.',
                'If you do not agree with any of these terms, you are prohibited from using or accessing this website. The materials contained on this website are protected by applicable copyright and trademark law under the laws of India.'
            ]
        },
        {
            id: 'account-registration',
            title: '2. Account & Registration',
            paragraphs: [
                'To make a purchase on our website, you may be required to create an account by providing accurate, complete, and current information including your full name, email address, mobile number, and shipping address. You are solely responsible for maintaining the confidentiality of your account credentials and for all activities that occur under your account.',
                'You must be at least 18 years of age to create an account and make purchases. By registering, you represent and warrant that all information you provide is truthful and accurate. We reserve the right to suspend or terminate accounts that contain false or misleading information.',
                'You agree to notify us immediately of any unauthorized use of your account or any other breach of security. We will not be liable for any loss or damage arising from your failure to comply with this provision.'
            ]
        },
        {
            id: 'handcrafted-products',
            title: '3. Handcrafted Product Disclaimer',
            paragraphs: [
                'Our products are handcrafted by skilled artisans using traditional techniques. Due to the handmade nature of our products, slight variations in colour, texture, pattern placement, and measurements are natural and expected. These variations are not defects but rather a testament to the authentic handcrafted nature of each piece.',
                'Product images on our website are representative and colours may vary slightly due to screen settings, lighting conditions during photography, and the natural variation in hand-dyed fabrics. We strive to represent our products as accurately as possible, but minor differences between the product image and the actual item received are inherent to handcrafted goods.',
                'Each piece may take additional time for production as artisans work on them individually. Production timelines mentioned are estimates and may vary depending on the complexity of the craft and seasonal factors affecting artisan availability.'
            ]
        },
        {
            id: 'orders-payment',
            title: '4. Orders & Payment',
            paragraphs: [
                'All orders placed through our website are subject to acceptance and availability. We reserve the right to refuse or cancel any order at our discretion, including orders where pricing errors have occurred, orders that appear to be placed by dealers or resellers, or orders that contain incorrect or unverifiable information.',
                'Prices for our products are quoted in Indian Rupees (INR) and are inclusive of applicable GST unless stated otherwise. Payment can be made via credit card, debit card, net banking, UPI, or Cash on Delivery (COD) where available. All online payments are securely processed through Razorpay, our trusted payment gateway, which employs industry-standard encryption and security protocols.',
                'Upon successful placement of an order, you will receive an order confirmation email with your order details and estimated delivery timeline. This confirmation does not constitute acceptance of your order; acceptance occurs only when the product has been dispatched from our facility.'
            ]
        },
        {
            id: 'shipping-delivery',
            title: '5. Shipping & Delivery',
            paragraphs: [
                'We endeavour to dispatch all ready-to-ship orders within 2-5 business days from the date of order confirmation. For handcrafted, made-to-order, or bespoke garments, additional production time of 7-21 business days may apply depending on the complexity of the craft and artisan availability.',
                'Delivery timelines vary depending on your location and the shipping method selected at checkout. Standard delivery within India typically takes 5-7 business days, while express shipping takes 2-3 business days. International shipping is available to select countries and typically takes 7-14 business days.',
                'Risk of loss and title for all items pass to you upon delivery to the shipping carrier. We partner with reputed logistics providers to ensure safe and timely delivery. In the event of a delivery delay caused by circumstances beyond our control, including natural disasters, strikes, or government restrictions, we shall not be held liable.'
            ]
        },
        {
            id: 'returns-exchange',
            title: '6. Returns & Exchange',
            paragraphs: [
                'We accept exchange requests within 7 days of delivery, provided the item is unused, unwashed, and in its original condition with all tags, labels, and packaging intact. To initiate an exchange, please contact our customer support team with your order number and reason for exchange.',
                'Due to the handcrafted nature of our products, minor variations in colour, texture, and pattern are not valid grounds for return or exchange. Custom-made, bespoke, or made-to-order garments, intimate wear, accessories marked as non-returnable, and products purchased during clearance or final sale events are not eligible for return or exchange.',
                'Refunds, where applicable, will be processed within 7-10 business days of receiving the returned product at our facility. The refund will be credited to your original payment method. For COD orders, refunds will be processed via bank transfer to the account details provided by you.'
            ]
        },
        {
            id: 'intellectual-property',
            title: '7. Intellectual Property',
            paragraphs: [
                'All content on this website, including but not limited to text, images, graphics, logos, artisan profiles, craft descriptions, product photography, and design elements, is our intellectual property or used with proper authorization and is protected by Indian copyright law.',
                'The traditional craft techniques, patterns, and motifs featured in our products belong to the cultural heritage of India and its artisan communities. While we celebrate and promote these traditions, we do not claim ownership over traditional craft knowledge. We work in partnership with artisan communities to ensure their cultural intellectual property is respected.',
                'You may not reproduce, distribute, or create derivative works from any content on this website without our express written permission. Unauthorized use may violate copyright, trademark, and other applicable laws.'
            ]
        },
        {
            id: 'governing-law',
            title: '8. Governing Law',
            paragraphs: [
                'These Terms and Conditions shall be governed by and construed in accordance with the laws of India, without regard to its conflict of law provisions. Any disputes arising out of or in connection with these terms shall be subject to the exclusive jurisdiction of the courts in Mumbai, Maharashtra.',
                'If any provision of these Terms and Conditions is found to be invalid or unenforceable, the remaining provisions shall remain in full force and effect. Our failure to enforce any right or provision of these terms shall not constitute a waiver of that right or provision.',
                'For any questions regarding these Terms and Conditions, please contact us at legal@maati.in or through our Contact page.'
            ]
        },
    ];

    return (
        <>
            <style>{`
                @import url('https://fonts.googleapis.com/css2?family=Cormorant+Infant:ital,wght@0,300;0,400;0,500;0,600;0,700;1,400&family=Source+Sans+3:wght@300;400;500;600;700&display=swap');
            `}</style>

            <div style={{ minHeight: '100vh', backgroundColor: '#FAF6F1', fontFamily: "'Source Sans 3', -apple-system, sans-serif" }}>
                <Header />

                {/* Hero */}
                <section style={{
                    padding: '120px 24px 60px', borderBottom: '1px solid #E8DDD0',
                    textAlign: 'center',
                }}>
                    <div style={{ maxWidth: '700px', margin: '0 auto' }}>
                        <div style={{
                            width: '56px', height: '56px', borderRadius: '50%',
                            backgroundColor: '#F3ECE4', display: 'flex',
                            alignItems: 'center', justifyContent: 'center', margin: '0 auto 20px',
                        }}>
                            <FileText size={24} color="#C4572A" />
                        </div>
                        <h1 style={{
                            fontFamily: "'Cormorant Infant', Georgia, serif",
                            fontSize: 'clamp(36px, 5vw, 52px)', fontWeight: 400,
                            color: '#5C3D2E', marginBottom: '12px',
                        }}>
                            Terms & Conditions
                        </h1>
                        <p style={{ fontSize: '14px', color: '#8B7355' }}>
                            Last updated: March 2026
                        </p>
                    </div>
                </section>

                {/* Content */}
                <div style={{ maxWidth: '800px', margin: '0 auto', padding: '60px 24px 80px' }}>
                    {/* Table of Contents */}
                    <div style={{
                        backgroundColor: '#FFFFFF', borderRadius: '12px',
                        border: '1px solid #E8DDD0', padding: '24px 28px',
                        marginBottom: '48px',
                    }}>
                        <h3 style={{ fontSize: '16px', fontWeight: 600, color: '#5C3D2E', margin: '0 0 16px 0' }}>
                            Table of Contents
                        </h3>
                        <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                            {sections.map(section => (
                                <a
                                    key={section.id}
                                    href={`#${section.id}`}
                                    style={{
                                        fontSize: '14px', color: '#C4572A', textDecoration: 'none',
                                        transition: 'color 0.2s',
                                    }}
                                    onMouseEnter={(e) => { e.currentTarget.style.color = '#D4683B'; }}
                                    onMouseLeave={(e) => { e.currentTarget.style.color = '#C4572A'; }}
                                >
                                    {section.title}
                                </a>
                            ))}
                        </div>
                    </div>

                    {/* Sections */}
                    {sections.map((section, i) => (
                        <div key={section.id} id={section.id} style={{ marginBottom: i < sections.length - 1 ? '48px' : '0' }}>
                            <h2 style={{
                                fontFamily: "'Cormorant Infant', Georgia, serif",
                                fontSize: '26px', fontWeight: 600, color: '#5C3D2E',
                                marginBottom: '20px', paddingBottom: '12px',
                                borderBottom: '1px solid #E8DDD0',
                            }}>
                                {section.title}
                            </h2>
                            {section.paragraphs.map((para, j) => (
                                <p key={j} style={{
                                    fontSize: '15px', color: '#5C3D2E', lineHeight: 1.8,
                                    marginBottom: j < section.paragraphs.length - 1 ? '16px' : '0',
                                    opacity: 0.85,
                                }}>
                                    {para}
                                </p>
                            ))}
                        </div>
                    ))}
                </div>

                <Footer />
            </div>
        </>
    );
};

export default TermsAndConditions22;
